package pwgs.ui.scenes.diagnosticsissuelistscene

import kotlinx.serialization.Serializable
import pwgs.ui.scenes.playererrorsscene.DiagnosticsIssueModel
import visage.rmi.VisageController

@VisageController(DiagnosticsIssueListSceneProps::class, DiagnosticsIssueListSceneModel::class)
interface DiagnosticsIssueList {
    fun load()
}

@Serializable
data class DiagnosticsIssueListSceneProps(
    val projectId: Long,
    val groupId: String
)

@Serializable
class DiagnosticsIssueListSceneModel(
    val items: List<DiagnosticsIssueModel>
) {
    var isLoading = true
}

